export enum Clients {
    Moovex = 'moovex',
    Taxelco = 'taxelco',
}

export enum Authorization {
    Account = 'account',
    Email = 'email',
    Phone = 'phone',
}

export enum TimeFormat {
    Time24 = '24',
    Time12 = '12',
}

export enum DistanceUnit {
    KM = 'km',
    MI = 'mi',
}